export default __webpack_public_path__ + "static/media/us_5.e285218a.mp3";